import { acConfig } from '@ac/library-utils/dist/declarations';

export const findRegionData = (regionCode: string) =>
  acConfig.regions.find(
    ({ code }) => code.toLowerCase() === regionCode.toLowerCase()
  );



// WEBPACK FOOTER //
// ./src/utils/region/findRegion.ts